module.exports = __webpack_public_path__ + "static/img/preview-pink-with-progress-bar.de2252cd.png";